import React from 'react';
import {
  EmptyStateIllustration,
  ErrorIllustration,
  NoResultsIllustration,
  PendingIllustration,
  StaringWorkIllustration,
  SuccessIllustration
} from '../assets/Illustrations';

export type IllustrationType =
  | 'startingWork'
  | 'emptyState'
  | 'error'
  | 'noResults'
  | 'success'
  | 'pending';

export interface IllustrationsProps {
  type: IllustrationType;
}

export const Illustration: React.FC<IllustrationsProps> = ({ type }) => {
  const getIllustration = () => {
    switch (type) {
      case 'startingWork':
        return <StaringWorkIllustration />;
      case 'emptyState':
        return <EmptyStateIllustration />;
      case 'error':
        return <ErrorIllustration />;
      case 'noResults':
        return <NoResultsIllustration />;
      case 'success':
        return <SuccessIllustration />;
      case 'pending':
        return <PendingIllustration />;
      default:
        return null;
    }
  };

  return <div>{getIllustration()}</div>;
};
